import { TopNavbar } from "./components/navigation/Navbar.tsx";
import Sidebar from "./components/navigation/Sidebar.tsx";
import { Outlet, useLocation } from "react-router-dom";
import { useAppSelector } from "./redux/hooks.ts";
import { useEffect, useState } from "react";

const routesWithoutNavigation = ["/auth/login", "/vault"];

export const Layout: React.FC = () => {
  const { pathname } = useLocation();
  const { userInfo } = useAppSelector((state) => state.auth);
  const [routeType, setRoutetype] = useState<1 | 2 | 3>(1);
  const isRouteWithoutNavigation = routesWithoutNavigation.some((route) =>
    pathname.startsWith(route),
  );

  const handleRouteTypes = () => {
    if (isRouteWithoutNavigation) setRoutetype(1);
    else if (!userInfo?.is_validated) setRoutetype(2);
    else if (userInfo?.is_validated) setRoutetype(3);
  };

  useEffect(() => {
    handleRouteTypes();
  }, [userInfo, pathname]);

  if (routeType === 1) return <Outlet />;

  return (
    <div className="flex w-screen h-full overflow-hidden">
      <div className="fixed top-0 left-0 h-full z-10">
        <Sidebar />
      </div>

      <div className="flex-grow pl-[272px]">
        {routeType == 2 ? (
          <div>
            <TopNavbar />
            <div><Outlet /></div>
          </div>
        ) : (
          <div className="h-full">
            <TopNavbar />
            <div className="bg-gray-100 min-h-screen p-4"><Outlet /></div>
          </div>
        )}
      </div>
    </div>
  );
};
